export const LOCAL_STORAGE_KEYS = {
    theme: 'theme',
    appVersion: 'app-version',
    lang: 'lang',
    betSlip: 'persist:betslip',
    descriptions: 'persist:descriptions',
    eventFilters: 'event-filters',
};

class LocalStorage {
    static excludedKeys = [
        LOCAL_STORAGE_KEYS.theme,
        LOCAL_STORAGE_KEYS.appVersion,
        LOCAL_STORAGE_KEYS.lang,
        LOCAL_STORAGE_KEYS.betSlip,
        LOCAL_STORAGE_KEYS.descriptions,
    ];

    static setItem(key, val) {
        let data = JSON.stringify(val);
        localStorage.setItem(key, data);
    }

    static getItem(key) {
        let data = localStorage.getItem(key);

        if (!data || data === 'undefined') return null;

        try {
            return JSON.parse(data);
        } catch (ex) {
            return null;
        }
    }

    static removeItem(key) {
        localStorage.removeItem(key);
    }

    static clear() {
        Object.keys(localStorage).forEach(key => {
            if (!LocalStorage.excludedKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });
    }
}

export default LocalStorage;
